import React from "react";
import { FaUserCircle } from "react-icons/fa";

const CustomOption = ({ innerProps, label, data }) => {
  return (
    <div {...innerProps} className="assignToEditor country-option">
      <img
        src={
          data.image ||
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Default_pfp.svg/2048px-Default_pfp.svg.png"
        }
        alt={label}
        width="20"
        height="20"
        className="assignToImageClass"
      />
      {label}
    </div>
  );
};
export default CustomOption;



// WEBPACK FOOTER //
// ./src/components/multiselectcustom/CustomOption.js